import { useEffect } from 'react';

import { useRouter } from 'expo-router';
import { useIntl } from 'react-intl';

import { routes } from 'navigation/routing';
import LoyaltyLoader from 'pages/loyalty/loyalty-loader/loyalty-loader';
import LoyaltyRewards from 'pages/loyalty/loyalty-rewards/loyalty-rewards';
import { LoyaltyRewardsTabs } from 'pages/loyalty/loyalty-rewards/loyalty-rewards-tabs';
import { useLoyaltyContext } from 'state/loyalty';
import { useLoyaltyUserState } from 'state/loyalty/hooks/use-loyalty-user-state';

export default function ActivateChallenge() {
  const { loadingQuests, userQuest, setShouldQuestsModalBeVisible } = useLoyaltyContext();
  const { loyaltyUser } = useLoyaltyUserState({ refreshOnMountOrFocus: true });
  const { formatMessage } = useIntl();
  const router = useRouter();

  useEffect(() => {
    if (!loadingQuests && loyaltyUser && !userQuest) {
      router.replace(routes.base);
    }
  }, [formatMessage, loadingQuests, userQuest, loyaltyUser, setShouldQuestsModalBeVisible, router]);

  if (loadingQuests) {
    return <LoyaltyLoader />;
  }

  return (
    <>
      <LoyaltyRewardsTabs />
      <LoyaltyRewards />
    </>
  );
}
